import React, { useState, useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { darkTheme, lightTheme } from './utils/Themes.js';
import Navbar from "./components/Navbar";
import { BrowserRouter as Router } from 'react-router-dom';
import styled from "styled-components";
import './App.css';
import HeroSection from "./components/HeroSection";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import ProjectDetails from "./components/ProjectDetails";
import { gsap } from "gsap";

const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
`;

const Wrapper = styled.div`
  background: linear-gradient(38.73deg, rgba(204, 0, 187, 0.15) 0%, rgba(201, 32, 184, 0) 50%), linear-gradient(141.27deg, rgba(0, 70, 209, 0) 50%, rgba(0, 70, 209, 0.15) 100%);
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 30% 98%, 0 100%);
`;

function App() {
  const [darkMode, setDarkMode] = useState(true);
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  useEffect(() => {
    // Only run custom cursor on desktop devices with mouse
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!isDesktop) return;

    const cursor = document.querySelector('.cursor');
    if (!cursor) return;

    const cursorScale = document.querySelectorAll('.cursor-scale');
    let mouseX = 0;
    let mouseY = 0;
    let animationFrameId;

    const updateCursorPosition = () => {
      if (cursor) {
        gsap.set(cursor, {
          css: {
            left: mouseX,
            top: mouseY
          }
        });
      }
    };

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;

      // Use requestAnimationFrame instead of GSAP ticker for better performance
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      animationFrameId = requestAnimationFrame(updateCursorPosition);
    };

    const handleMouseLeave = () => {
      if (cursor) {
        cursor.classList.remove('grow');
        cursor.classList.remove('grow-small');
      }
    };

    const handleMouseMoveOnLink = (link) => () => {
      if (cursor) {
        cursor.classList.add('grow');
        if (link.classList.contains('small')) {
          cursor.classList.remove('grow');
          cursor.classList.add('grow-small');
        }
      }
    };

    // Store event handlers for proper cleanup
    const linkHandlers = new Map();

    // Always enable cursor tracking regardless of modal state
    window.addEventListener("mousemove", handleMouseMove);

    cursorScale.forEach(link => {
      const moveHandler = handleMouseMoveOnLink(link);
      linkHandlers.set(link, { moveHandler, handleMouseLeave });
      link.addEventListener('mouseleave', handleMouseLeave);
      link.addEventListener('mousemove', moveHandler);
    });

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      cursorScale.forEach(link => {
        const handlers = linkHandlers.get(link);
        if (handlers) {
          link.removeEventListener('mouseleave', handlers.handleMouseLeave);
          link.removeEventListener('mousemove', handlers.moveHandler);
        }
      });
      linkHandlers.clear();
    };
  }, []);

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <Navbar />
        <Body>
          <div className="cursor"></div>
          <HeroSection />
          <Wrapper>
            <Skills />
            <Experience />
          </Wrapper>
          <Projects openModal={openModal} setOpenModal={setOpenModal} />
          <Wrapper>
            <Education />
            <Contact />
          </Wrapper>
          <Footer />
          {openModal.state &&
            <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
          }
        </Body>
      </Router>
    </ThemeProvider>
  );
}

export default App;
